import { render, staticRenderFns } from "./AssistanceSidebarAdd.vue?vue&type=template&id=59a26994&"
import script from "./AssistanceSidebarAdd.vue?vue&type=script&lang=js&"
export * from "./AssistanceSidebarAdd.vue?vue&type=script&lang=js&"
import style0 from "./AssistanceSidebarAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports